// extracted by mini-css-extract-plugin
export default {"button":"catalogEditValueInput_button__XWZuu"};